/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Fast Inquiry Create styled
 *
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.36.0
 */

import styled from 'styled-components';

export const RadioButtonsContainerStyled = styled.div.attrs({
    className: 'radio-buttons',
})`
   display: flex;
   flex-direction: column;
   width: fit-content;
   gap: 8px;
`;
